"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSokComponents = void 0;
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var i18n_1 = __importDefault(require("../../../../translations/i18n"));
var tags_1 = require("./tags");
var sokItemScaleNumberLabelStyles = {
    fontFamily: 'Futura Std Extra Bold Condensed',
    letterSpacing: '0.5px',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    borderRadius: 10,
    padding: 4
};
var cardBoxShadowAland = 'inset 0 0 0 8px #0060ae, inset 0 0 0 16px #fed400, inset 0 0 0 24px #dc000c';
var generateSokCustomStyles = function (_a) {
    var itemsCount = _a.itemsCount, itemNameStyles = _a.itemNameStyles, itemDescriptionStyles = _a.itemDescriptionStyles, itemPriceStyles = _a.itemPriceStyles, itemPriceUnitStyles = _a.itemPriceUnitStyles, itemImageStyles = _a.itemImageStyles, itemCardStyles = _a.itemCardStyles, itemScaleNumberStyles = _a.itemScaleNumberStyles, fillColor = _a.fillColor, tag = _a.tag;
    var commonScaleNumberContainerStyles = {
        position: 'absolute',
        zIndex: 3
    };
    var commonPriceStyles = __assign({ zIndex: 4, position: 'absolute' }, itemPriceStyles);
    var sokItemScaleNumberStyles = itemScaleNumberStyles;
    var commonUnitStyles = __assign({ display: 'inline-block', position: 'relative', textShadow: '0px 0px 20px #ffffff' }, itemPriceUnitStyles);
    var commonPriceNumberStyles = {
        display: 'inline-block',
        color: tag === seesignage_utils_1.ProductTags.new ? 'black' : fillColor,
        textShadow: '0px 0px 20px #ffffff',
        letterSpacing: '-3px'
    };
    var commonImageStyles = __assign({ zIndex: '0', padding: '0 30px 0 0' }, itemImageStyles);
    var sokItemCardStyles = __assign({}, itemCardStyles);
    if (fillColor) {
        sokItemCardStyles = __assign(__assign({}, sokItemCardStyles), { 
            // Special case for Åland and local tag
            boxShadow: i18n_1.default.language === 'sv' && tag === seesignage_utils_1.ProductTags.local
                ? cardBoxShadowAland
                : "inset 0 0 0 20px ".concat(fillColor), borderRadius: '30px' });
    }
    if (itemsCount === 1) {
        return {
            sokItemScaleNumberLabelStyles: sokItemScaleNumberLabelStyles,
            sokItemScaleNumberContainerStyles: __assign(__assign({}, commonScaleNumberContainerStyles), { transform: 'scale(1.7)', bottom: '15%', right: '10%' }),
            sokItemScaleNumberStyles: sokItemScaleNumberStyles,
            sokItemCardStyles: sokItemCardStyles,
            sokItemNameStyles: __assign(__assign({}, itemNameStyles), { padding: '100px 40px 0px 80px', height: '35%', position: 'asdsfs' }),
            sokItemDescriptionStyles: __assign(__assign({}, itemNameStyles), { padding: '0px 40px 0px 80px' }),
            sokItemPriceStyles: __assign(__assign({}, commonPriceStyles), { bottom: '70px', left: '80px' }),
            sokItemIntegersStyles: __assign(__assign({}, commonPriceNumberStyles), { fontSize: '350px' }),
            sokItemDecimalsStyles: __assign(__assign({}, commonPriceNumberStyles), { fontSize: '120px', position: 'relative', top: '-1.4em' }),
            sokItemUnitStyles: __assign(__assign({}, commonUnitStyles), { color: '#000000', fontSize: '78px', left: '-125px' }),
            sokItemImageStyles: __assign({}, commonImageStyles)
        };
    }
    if (itemsCount === 2) {
        return {
            sokItemScaleNumberLabelStyles: sokItemScaleNumberLabelStyles,
            sokItemScaleNumberContainerStyles: __assign(__assign({}, commonScaleNumberContainerStyles), { transform: 'scale(1.3)', bottom: '12%', right: '10%' }),
            sokItemScaleNumberStyles: sokItemScaleNumberStyles,
            sokItemCardStyles: sokItemCardStyles,
            sokItemNameStyles: __assign(__assign({}, itemNameStyles), { padding: '100px 60px 0px 60px', height: '35%' }),
            sokItemDescriptionStyles: __assign(__assign({}, itemNameStyles), { padding: '0px 60px 0px 60px' }),
            sokItemPriceStyles: __assign(__assign({}, commonPriceStyles), { bottom: '70px', left: '80px' }),
            sokItemIntegersStyles: __assign(__assign({}, commonPriceNumberStyles), { fontSize: '250px' }),
            sokItemDecimalsStyles: __assign(__assign({}, commonPriceNumberStyles), { fontSize: '100px', position: 'relative', top: '-1.1em' }),
            sokItemUnitStyles: __assign(__assign({}, commonUnitStyles), { color: '#000000', display: 'inline-block', fontSize: '60px', left: '-85px', position: 'relative' }),
            sokItemImageStyles: __assign({}, commonImageStyles)
        };
    }
    if (itemsCount === 3 || itemsCount === 4) {
        return {
            sokItemScaleNumberLabelStyles: sokItemScaleNumberLabelStyles,
            sokItemScaleNumberContainerStyles: __assign(__assign({}, commonScaleNumberContainerStyles), { transform: 'scale(1.1)', bottom: '10%', right: '35%' }),
            sokItemScaleNumberStyles: sokItemScaleNumberStyles,
            sokItemCardStyles: sokItemCardStyles,
            sokItemNameStyles: __assign(__assign({}, itemNameStyles), { padding: '70px 40px 0px', height: '40%' }),
            sokItemDescriptionStyles: __assign(__assign({}, itemNameStyles), { padding: '10px 40px 0px 40px' }),
            sokItemPriceStyles: __assign(__assign({}, commonPriceStyles), { bottom: '30px', left: '40px' }),
            sokItemIntegersStyles: __assign(__assign({}, commonPriceNumberStyles), { fontSize: '180px' }),
            sokItemDecimalsStyles: __assign(__assign({}, commonPriceNumberStyles), { fontSize: '80px', position: 'relative', top: '-0.9em' }),
            sokItemUnitStyles: __assign(__assign({}, commonUnitStyles), { color: '#000000', display: 'inline-block', fontSize: '45px', left: '-85px', position: 'relative' }),
            sokItemImageStyles: __assign({}, commonImageStyles)
        };
    }
    if (itemsCount === 5 || itemsCount === 6) {
        return {
            sokItemScaleNumberLabelStyles: sokItemScaleNumberLabelStyles,
            sokItemScaleNumberContainerStyles: __assign(__assign({}, commonScaleNumberContainerStyles), { bottom: '10%', right: '5%' }),
            sokItemScaleNumberStyles: sokItemScaleNumberStyles,
            sokItemCardStyles: sokItemCardStyles,
            sokItemNameStyles: __assign(__assign({}, itemNameStyles), { padding: '40px 80px 0px 40px', height: '40%' }),
            sokItemDescriptionStyles: __assign(__assign({}, itemNameStyles), { padding: '10px 80px 0px 40px' }),
            sokItemPriceStyles: __assign(__assign({}, commonPriceStyles), { bottom: '30px', left: '35px' }),
            sokItemIntegersStyles: __assign(__assign({}, commonPriceNumberStyles), { fontSize: '170px' }),
            sokItemDecimalsStyles: __assign(__assign({}, commonPriceNumberStyles), { fontSize: '72px', position: 'relative', top: '-1em' }),
            sokItemUnitStyles: __assign(__assign({}, commonUnitStyles), { color: '#000000', display: 'inline-block', fontSize: '42px', left: '-75px', position: 'relative' }),
            sokItemImageStyles: __assign({}, commonImageStyles)
        };
    }
    if (itemsCount === 7 || itemsCount === 8) {
        return {
            sokItemScaleNumberLabelStyles: sokItemScaleNumberLabelStyles,
            sokItemScaleNumberContainerStyles: __assign(__assign({}, commonScaleNumberContainerStyles), { transform: 'scale(0.8)', bottom: '5%', right: '5%' }),
            sokItemScaleNumberStyles: sokItemScaleNumberStyles,
            sokItemCardStyles: sokItemCardStyles,
            sokItemNameStyles: __assign(__assign({}, itemNameStyles), { padding: '40px 80px 0px 40px', height: '35%' }),
            sokItemDescriptionStyles: __assign(__assign({}, itemNameStyles), { padding: '0px 80px 0px 40px' }),
            sokItemPriceStyles: __assign(__assign({}, commonPriceStyles), { bottom: '35px', left: '30px' }),
            sokItemIntegersStyles: __assign(__assign({}, commonPriceNumberStyles), { fontSize: '150px' }),
            sokItemDecimalsStyles: __assign(__assign({}, commonPriceNumberStyles), { fontSize: '60px', position: 'relative', top: '-1.1em' }),
            sokItemUnitStyles: __assign(__assign({}, commonUnitStyles), { color: '#000000', display: 'inline-block', fontSize: '40px', left: '-60px', position: 'relative' }),
            sokItemImageStyles: __assign({}, commonImageStyles)
        };
    }
    return {
        sokItemScaleNumberLabelStyles: sokItemScaleNumberLabelStyles,
        sokItemScaleNumberContainerStyles: __assign(__assign({}, commonScaleNumberContainerStyles), { transform: 'scale(1)' }),
        sokItemScaleNumberStyles: sokItemScaleNumberStyles,
        sokItemCardStyles: sokItemCardStyles,
        sokItemNameStyles: itemNameStyles,
        sokItemDescriptionStyles: itemDescriptionStyles,
        sokItemPriceStyles: __assign(__assign({}, commonPriceStyles), { bottom: '20px', left: '40px' }),
        sokItemIntegersStyles: __assign(__assign({}, commonPriceNumberStyles), { fontSize: '180px' }),
        sokItemDecimalsStyles: __assign(__assign({}, commonPriceNumberStyles), { fontSize: '80px', position: 'relative', top: '-0.9em' }),
        sokItemUnitStyles: __assign(__assign({}, commonUnitStyles), { color: '#000000', display: 'inline-block', fontSize: '45px', left: '-85px', position: 'relative' }),
        sokItemImageStyles: {}
    };
};
/**
 * Get custom SOK components
 * Return empty object if not SOK chain
 */
var getSokComponents = function (_a) {
    var itemsCount = _a.itemsCount, tags = _a.tags, itemNameStyles = _a.itemNameStyles, itemDescriptionStyles = _a.itemDescriptionStyles, itemPriceStyles = _a.itemPriceStyles, itemPriceUnitStyles = _a.itemPriceUnitStyles, itemImageStyles = _a.itemImageStyles, itemCardStyles = _a.itemCardStyles, itemScaleNumberStyles = _a.itemScaleNumberStyles;
    if (tags) {
        var tag = (0, tags_1.getCurrentTag)(tags);
        if (tag) {
            var fillColor = (0, tags_1.getSokFillColor)(tag);
            if (fillColor) {
                return {
                    SokTagSvg: (0, tags_1.generateSokTagSvg)({
                        itemsCount: itemsCount,
                        tag: tag,
                        fillColor: fillColor
                    }),
                    customSokStyles: generateSokCustomStyles({
                        itemsCount: itemsCount,
                        itemNameStyles: itemNameStyles,
                        itemDescriptionStyles: itemDescriptionStyles,
                        itemPriceStyles: itemPriceStyles,
                        itemPriceUnitStyles: itemPriceUnitStyles,
                        itemImageStyles: itemImageStyles,
                        itemCardStyles: itemCardStyles,
                        itemScaleNumberStyles: itemScaleNumberStyles,
                        fillColor: fillColor,
                        tag: tag
                    })
                };
            }
        }
    }
    return {
        SokTagSvg: undefined,
        customSokStyles: generateSokCustomStyles({
            itemsCount: itemsCount,
            itemNameStyles: itemNameStyles,
            itemDescriptionStyles: itemDescriptionStyles,
            itemPriceStyles: itemPriceStyles,
            itemPriceUnitStyles: itemPriceUnitStyles,
            itemCardStyles: itemCardStyles,
            itemScaleNumberStyles: itemScaleNumberStyles,
            itemImageStyles: itemImageStyles
        })
    };
};
exports.getSokComponents = getSokComponents;
//# sourceMappingURL=sok.js.map